// Pomocníci modulu "Úpravy trenažérů": volání API, formátování a součty nabídky (stejné zaokrouhlování jako na serveru).

export const API = '/api/upgrades';

export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const err = new Error(json.details?.[0]?.msg || json.error || `Chyba ${res.status}`);
    err.status = res.status;
    err.data = json.data;
    throw err;
  }
  return json.warning ? { ...json.data, _warning: json.warning } : json.data;
}

const pad = (n) => String(n).padStart(2, '0');
const localIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const todayIso = () => localIso(new Date());
export const addDaysIso = (iso, days) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + days);
  return localIso(d);
};

export const czDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d ? `${Number(d)}. ${Number(m)}. ${y}` : iso;
};

export const czDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const dateRange = (job) => {
  if (!job.planned_start) return 'Bez termínu';
  const end = job.planned_end && job.planned_end !== job.planned_start ? ` – ${czDate(job.planned_end)}` : '';
  return `${czDate(job.planned_start)}${end}`;
};

const nf = new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const money = (n) => `${nf.format(Number(n) || 0)} Kč`;
export const moneyShort = (n) => `${new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 }).format(Number(n) || 0)} Kč`;

// Same arithmetic as services/upgrades/pricing.js on the server: lines are rounded half-up to whole haléře in integers
const lineCents = (item) => Math.floor((Math.round(Number(item.qty) * 100) * Math.round(Number(item.unit_price) * 100) + 50) / 100);
export const lineTotal = (item) => lineCents(item) / 100;

export function computeTotals(items, discountPercent = 0, vatRate = 21) {
  const subtotalC = items.reduce((sum, i) => sum + (Number.isFinite(lineCents(i)) ? lineCents(i) : 0), 0);
  const discountC = Math.round((subtotalC * (Number(discountPercent) || 0)) / 100);
  const netC = subtotalC - discountC;
  const vatC = Math.round((netC * (Number(vatRate) || 0)) / 100);
  return { subtotal: subtotalC / 100, discount: discountC / 100, net: netC / 100, vat: vatC / 100, gross: (netC + vatC) / 100 };
}

export const initials = (name) => String(name || '').split(/\s+/).filter(Boolean).map((p) => p[0]).slice(0, 2).join('').toUpperCase();
export const newKey = () => `k${Math.random().toString(36).slice(2, 10)}`;
